import { render, staticRenderFns } from "./newShipment.vue?vue&type=template&id=ef050dba&"
import script from "./newShipment.vue?vue&type=script&lang=js&"
export * from "./newShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports